import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const ProductScreenshot = makeShortcode("ProductScreenshot");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`You can sync and query files and folders from Google Cloud Storage (GCS) in PostHog by setting up a link.`}</p>
    <h2 {...{
      "id": "step-1-creating-a-bucket-in-gcs"
    }}>{`Step 1: Creating a bucket in GCS`}</h2>
    <ol>
      <li parentName="ol">{`Go to your Google Cloud console.`}</li>
      <li parentName="ol">{`Create a bucket in GCS. `}
        <ul parentName="li">
          <li parentName="ul">{`For location, we recommend choosing `}<inlineCode parentName="li">{`us-east1`}</inlineCode>{` for US Cloud or `}<inlineCode parentName="li">{`europe-west3`}</inlineCode>{` for EU Cloud to keep them close to our servers.`}</li>
          <li parentName="ul">{`For storage class, choose `}<inlineCode parentName="li">{`Standard`}</inlineCode>{`.`}</li>
          <li parentName="ul">{`For access control, choose `}<inlineCode parentName="li">{`Uniform`}</inlineCode>{`.`}</li>
        </ul>
      </li>
      <li parentName="ol">{`Upload your data to the bucket. This can be as simple as a `}<inlineCode parentName="li">{`.csv`}</inlineCode>{` file like this:`}</li>
    </ol>
    <pre><code parentName="pre" {...{
        "className": "language-csv"
      }}>{`name,age
John,30
Jane,25
`}</code></pre>
    <h2 {...{
      "id": "step-2-set-up-a-service-account"
    }}>{`Step 2: Set up a service account`}</h2>
    <p>{`GCS uses service accounts to control access to resources. We need one to connect to GCS. To create one:`}</p>
    <ol>
      <li parentName="ol">{`Go to the `}<a parentName="li" {...{
          "href": "https://console.cloud.google.com/iam-admin/serviceaccounts"
        }}>{`service accounts page`}</a>{` in the GCS console and click `}<strong parentName="li">{`Create service account`}</strong>{`.`}</li>
      <li parentName="ol">{`Fill in the account name and ID and click `}<strong parentName="li">{`Create and continue`}</strong>{`.`}</li>
      <li parentName="ol">{`Grant the account the `}<strong parentName="li">{`Storage Object User`}</strong>{` role.`}</li>
      <li parentName="ol">{`Click `}<strong parentName="li">{`Done`}</strong>{`.`}</li>
    </ol>
    <h2 {...{
      "id": "step-3-set-up-access-keys"
    }}>{`Step 3: Set up access keys.`}</h2>
    <ol>
      <li parentName="ol">{`Go to the `}<a parentName="li" {...{
          "href": "https://console.cloud.google.com/storage/settings"
        }}>{`cloud storage settings page`}</a>{` and click the `}<strong parentName="li">{`Interoperability`}</strong>{` tab.`}</li>
      <li parentName="ol">{`Click `}<strong parentName="li">{`Create a key for another service account`}</strong>{`.`}</li>
      <li parentName="ol">{`Select the service account you created in step 2 and click `}<strong parentName="li">{`create key`}</strong>{`.`}</li>
      <li parentName="ol">{`Copy both the access key and secret. Save them some place safe because you'll need to regenerate them if you lose them.`}</li>
    </ol>
    <p><img parentName="p" {...{
        "src": "https://res.cloudinary.com/dmukukwp6/image/upload/Clean_Shot_2024_07_17_at_12_57_42_2x_ace42b1d0e.png",
        "alt": "Access keys"
      }}></img></p>
    <h2 {...{
      "id": "step-4-create-the-table-in-posthog"
    }}>{`Step 4: Create the table in PostHog`}</h2>
    <ol>
      <li parentName="ol">{`Go to the `}<a parentName="li" {...{
          "href": "https://us.posthog.com/pipeline/sources"
        }}>{`Data pipeline page`}</a>{` and the sources tab in PostHog`}</li>
      <li parentName="ol">{`Click `}<strong parentName="li">{`New source`}</strong>{`. Under self managed, look for `}<strong parentName="li">{`Google Cloud Storage`}</strong>{` and click `}<strong parentName="li">{`Link`}</strong></li>
      <li parentName="ol">{`Fill the table name, then use the data from GCS: `}
        <ul parentName="li">
          <li parentName="ul">{`For files URL pattern, use `}<inlineCode parentName="li">{`https://storage.googleapis.com/`}</inlineCode>{` followed by your bucket and file or folder name like `}<inlineCode parentName="li">{`https://storage.googleapis.com/posthog-warehouse/july12_google_ads_fixed.csv`}</inlineCode>{`. You can also use `}<inlineCode parentName="li">{`*`}</inlineCode>{` to query multiple files.`}</li>
          <li parentName="ul">{`Choose the correct file format`}</li>
          <li parentName="ul">{`For access key, use your Access Key ID`}</li>
          <li parentName="ul">{`For secret key, use your Secret Access Key`}</li>
        </ul>
      </li>
      <li parentName="ol">{`Click `}<strong parentName="li">{`Next`}</strong></li>
    </ol>
    <ProductScreenshot imageLight="https://res.cloudinary.com/dmukukwp6/image/upload/Clean_Shot_2024_07_17_at_13_03_25_2x_0ec0ddecaf.png" imageDark="https://res.cloudinary.com/dmukukwp6/image/upload/Clean_Shot_2024_07_17_at_13_03_43_2x_465b2300b3.png" alt="GCS source configuration form" classes="rounded" mdxType="ProductScreenshot" />
    <h2 {...{
      "id": "step-5-query-the-table"
    }}>{`Step 5: Query the table`}</h2>
    <p>{`Once it is done syncing, you can now `}<a parentName="p" {...{
        "href": "/docs/data-warehouse/query"
      }}>{`query`}</a>{` your new table using the table name.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      